interface Props {
  tagId: string
  taskId: string
}

export const createTaskTagDropdownId = ({ tagId, taskId }: Props) => {
  return `_${taskId}_${tagId}`
}
